
<template>
  <div id="cardProduct-big-v2" :class="(lodging.lodging_discounts && lodging.lodging_discounts.length > 0) || showLastAvailabilityInsert ? 'card_with_discount' : 'card_without_discount'"
       @click="$emit('selectedCard', dataMarker)"
       @mouseenter="handleCardHover(true)"
       @mouseleave="handleCardHover(false)"
       v-if="lodgingMount && !isPhone">
    <div class="catch-hub-phone" v-if="lodging.lodging_description && lodging.lodging_description.catch_sentence">
      <p class="merriweather-italic">{{ lodging.lodging_description.catch_sentence }}</p>
    </div>
    <div class="catch-hub-phone" v-else>
      <p class="merriweather-italic">Un havre aussi éco-responsable que luxueux</p>
    </div>
    
    <div class="hub-img-zoom" @click="goToLodging()">
      <div class="h-100 swiper-container lodging-image-slider">
        <div class="swiper-wrapper">
          <div
            v-for="(photo, index) in displayPhotos"
            :key="`${lodging.id}_${index}`"
            class="swiper-slide"
            :style="index < 2 ? { backgroundImage: `url('${photo}')` } : {}"
            :data-src="photo"
          >
            <div class="image-overlay"></div>
            <div class="experience-name-text merriweather-reg-24" v-if="experienceName">
                {{ experienceName[0] }} <br>
                <span class="merriweather-bold-italic-24">{{ experienceName[1] }}</span>
            </div>
          </div>
        </div>
        <div class="swiper-button-next" @click.stop></div>
        <div class="swiper-button-prev" @click.stop></div>
        <div class="swiper-pagination"></div>
      </div>
      
      <div class="sticker-hub d-flex mt-4 pl-2" style="position: absolute; top: 0; left: 0; z-index: 10; pointer-events: auto;" @mouseover="upHere = true" @mouseleave="upHere = false">
        <img :src="greenNotePicto(lodging.score.toFixed())" :alt="lodging.score.toFixed()" v-if="lodging.score && !upHere" />
        <div class="sticker-info d-flex" v-if="lodging.score">
          <div v-if="isPhone" style="position:fixed;background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #A5D3AE;border-radius: 0px 53px 53px 0px;opacity: 1;" v-show="upHere">
            <div class="row pl-2">
              <div class="pl-3 ">
                <img style="width: 14px;height: 21px;" :src="greenNotePicto(lodging.score.toFixed())" :alt="lodging.score.toFixed()" v-if="lodging.score" />
              </div>
              <p class="raleway-reg-p13 mb-0 pl-1 pr-2">
                <b>{{ lodging.score.toFixed() }}</b
                >/10
              </p>
            </div>
            <div class="pl-4">
              <div class="mt-2">
                <p style="text-align: left;font: normal normal bold 13px/15px Raleway;letter-spacing: 0px;color: #000000;text-transform: uppercase;opacity: 1;">
                  LA GREEN NOTE
                </p>
              </div>
              <div class="mt-3 pr-2">
                <p style="font: normal normal bold 13px/15px Raleway;">
                  Pour intégrer la sélection, un hébergement doit obtenir une note globale d'au moins 5/10 — un niveau qui reflète déjà un fort engagement environnemental.</p>
              </div>
              <div class="mt-2 pr-2">
                <p style="text-align: left;font: normal normal normal 12px/14px Raleway;letter-spacing: 0px;color: #000000;opacity: 1;">
                  Développée par Hortense, la Green Note évalue les établissements selon 10 critères d’éco-responsabilité. Chaque critère est noté sur 10, permettant d’attribuer une note globale de 1 à 10.</br></br>Les 10 critères d'éco-responsabilité pris en compte dans l'évaluation incluent des aspects tels que la gestion des déchets, l'efficacité énergétique, l'utilisation de sources d'énergie renouvelables, la conservation de l'eau, la promotion du transport durable, l'utilisation de matériaux écologiques, la sensibilisation à l'environnement, la formation du personnel aux éco-gestes etc.</br></br>À travers la Green Note, Hortense valorise les hébergements engagés et accompagne les voyageurs vers des choix plus durables.</p>
              </div>
            </div>
          </div>
          <p class="raleway-reg-p13 mb-0 pl-1 pr-2">
            <b>{{ lodging.score.toFixed() }}</b
            >/10
          </p>
          <p class="raleway-reg-p13 mb-0 pl-1 pr-2">Green note</p>
        </div>
      </div>
    </div>
    
    <div v-if="!isPhone" style="position:absolute; z-index: 9999; width: 48%;height: 338px;background-color: rgba(255, 255, 255, 1);border: 1px solid #A5D3AE;border-radius: 0px 53px 53px 0px;opacity: 1;pointer-events: none;" v-show="upHere">
      <div class="row pl-2">
        <div class="pl-3 ">
          <img style="width: 14px;height: 21px;" :src="greenNotePicto(lodging.score.toFixed())" :alt="lodging.score.toFixed()" v-if="lodging.score" />
        </div>
        <p class="raleway-reg-p13 mb-0 pl-1 pr-2">
          <b>{{ lodging.score.toFixed() }}</b
          >/10
        </p>
      </div>
      <div class="pl-4">
        <div class="mt-2">
          <p style="text-align: left;font: normal normal bold 13px/15px Raleway;letter-spacing: 0px;color: #000000;text-transform: uppercase;opacity: 1;">
            LA GREEN NOTE
          </p>
        </div>
        <div class="mt-3 pr-2">
          <p style="font: normal normal bold 13px/15px Raleway;">
            Pour intégrer la sélection, un hébergement doit obtenir une note globale d'au moins 5/10 — un niveau qui reflète déjà un fort engagement environnemental.</p>
        </div>
        <div class="mt-2 pr-2">
          <p style="text-align: left;font: normal normal normal 12px/14px Raleway;letter-spacing: 0px;color: #000000;opacity: 1;">
            Développée par Hortense, la Green Note évalue les établissements selon 10 critères d’éco-responsabilité. Chaque critère est noté sur 10, permettant d’attribuer une note globale de 1 à 10.</br></br>Les 10 critères d'éco-responsabilité pris en compte dans l'évaluation incluent des aspects tels que la gestion des déchets, l'efficacité énergétique, l'utilisation de sources d'énergie renouvelables, la conservation de l'eau, la promotion du transport durable, l'utilisation de matériaux écologiques, la sensibilisation à l'environnement, la formation du personnel aux éco-gestes etc.</br></br>À travers la Green Note, Hortense valorise les hébergements engagés et accompagne les voyageurs vers des choix plus durables.</p>
        </div>
      </div>
    </div>
    
    <!-- Content Section -->
    <div class="card-hub-info">
      <!-- Dernières Disponibilités Insert -->
      <div v-if="showLastAvailabilityInsert" class="dernières-disponibilités-insert">
        <div class="insert-content">
          <span class="insert-icon"><img src="../../images/wait_icon.svg" style="width: 7px; height: 9px;"></img></span>
          <span class="insert-text text-uppercase raleway-semi-p11">DERNIÈRES DISPONIBILITÉS</span>
        </div>
      </div>

      <!-- Discount Badges -->
      <div class="card-discount-section d-flex justify-content-between w-100" :class="isPhone ? 'align-items-center' : ''" v-if="lodging.lodging_discounts && lodging.lodging_discounts.length > 0">
         <CardDiscountBadges v-if="showFromLodgingsPage" :lodging="lodging" />
      </div>
      <div class="hub-header d-flex align-items-start mb-2">
        <div class="d-flex align-items-center">
          <h2 class="raleway-bold-h3 no-translate mr-1 mb-0">{{ lodging.name }}</h2>
          <div
            v-if="Number(lodging.classification_outside_france) > 0"
            class="d-flex standing mb-1"
          >
            <div
              v-for="i in Number(lodging.classification_outside_france)"
              :key="i"
            >
              <img
                src="../../images/picto_logement_entier_black.svg"
                alt="Classification - hors atout france"
                style="width: 15px; height: 15px; margin: 0 1px;"
              />
            </div>
          </div>
          <div v-else-if="lodging.standing && parseInt(lodging.standing) > 0" class="standing mb-1">
            <img src="../../images/Etoiles.svg" v-set-alt v-if="lodging.standing" v-for="i in Math.max(0, parseInt(lodging.standing) || 0)" :key="i" />
            <img v-if="lodging.standing && parseInt(lodging.standing) > 0" src="../../images/blanc.png" alt="white" />
          </div>
        </div>
        <div class="like-icon ml-2">
          <img src="../../images/wishlistOn.svg" class="mb-2" v-set-alt v-if="isIncludeInWishlist()" @click.stop="toggleLike()" />
          <img src="../../images/wishlist.svg" class="mb-2" v-set-alt v-else @click.stop="toggleLike()" />
        </div>
      </div>
      <div class="d-flex align-items-center mb-1" style="gap: 0.2rem;">
        <div class="lodge-type raleway-semi-p11 text-uppercase">
          {{ typeLabels[this.lodging.type] || "Lodges et lieux insolites" }}
        </div>
        <span style="font-style: normal;" v-if="lodging.is_entire">•</span>
        <span class="raleway-reg-p12" v-if="lodging.is_entire">
          {{ this.lodging.rooms_count || 1 }}
          {{ this.lodging.rooms_count > 1 ? 'Chambres' : 'Chambre' }}
        </span>
      </div>
      <p class="description-hub mb-0 raleway-reg-p12" v-if="fullLocation">{{ fullLocation }} <span @click="displayMapfind" class="location-hub-desktop raleway-semi-p12">Voir sur la carte</span></p>
      <div @click="goToLodging()" id="green-experience-section">
        <!-- <div class="header" v-if="lodging.lodging_description.green_experience ">
          <span class="nights">+ DE 3 NUITS = GREEN EXPÉRIENCE</span>
          <span class="visit">{{ lodging.lodging_description.green_experience }}</span>
        </div> -->
        <div class="discount-details" v-if="lodging.lodging_description.green_experience_two">
          <img src="../../images/discount.png" class="discount-image" />
          <div class="details">
            <div class="details-1">
              <span class="discount">{{lodging.lodging_description.green_experience_two}}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.lodging.lowest_price" style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 5px;" class="raleway-reg-p13 mt-auto">
        <div class="d-flex flex-column align-items-end w-100">
          <div class="d-flex flex-column align-items-end">
            <p class="raleway-reg-p15 mb-0">À partir de</p>
            <p class="raleway-semi-p15 mb-0">{{ this.lodging.lowest_price }} EUR <span class="raleway-reg-p13 mb-0">par nuit</span></p>
          </div>
        </div>
      </div>
      <div class="reviews-btn" :class="lodging.lodging_description.green_experience || lodging.lodging_description.green_experience_two ? '' : 'flex-column'">
        <div class="hub-reviews d-flex" v-if="lodging.ratings.length > 0">
          <img class="mt-2 mr-2" src="../../images/avis.svg" v-set-alt />
          <div class="review-info d-flex">
            <div class="score-hub d-flex" v-if="ratedLodgings">
              <i class="fa-solid fa-star ta-starr pl-1" style="font-size: 13px; margin-top: 3px;"></i>
              <p class="raleway-semi-p13 mb-0 pl-1 pr-2">
                <b>{{ this.lodging.lodging_description.rating_value || average }}</b
                >/5
              </p>
              <a :href="'/reservation-hotel/' + lodging.slug + '/avis'" class="link-hortense"> {{ this.lodging.ratings.length }} avis</a>
            </div>
            <p class="raleway-reg-p13">Note des voyageurs</p>
          </div>
        </div>
        <a v-if="exclusive" @click="openInNewWindowTwo(exclusive.slug, lodging.slug)" :href="'/offres-exclusives/' + this.exclusive.slug + '/' + this.lodging.slug" class="xs-btn-primary text-center" target="_blank" rel="noopener noreferrer">Voir les disponibilités</a>
        <a v-else @click="openInNewWindow(lodging.slug)" class="xs-btn-primary text-center ml-auto mt-auto">Voir les disponibilités</a>
      </div>
    </div>
  </div>
  
  <!-- Mobile Version -->
  <div id="cardProduct-big-v2"
       @click="$emit('selectedCard', dataMarker)"
       @mouseenter="handleCardHover(true)"
       @mouseleave="handleCardHover(false)"
       v-else>
    <div class="hub-img-zoom" @click="goToLodging()">
      <div class="swiper-container lodging-image-slider-mobile">
        <div class="swiper-wrapper">
          <div
            v-for="(photo, index) in displayPhotos"
            :key="`${lodging.id}_${index}`"
            class="swiper-slide"
            :style="index < 2 ? { backgroundImage: `url('${photo}')` } : {}"
            :data-src="photo"
          >
            <div class="image-overlay"></div>
            <div class="experience-name-text merriweather-reg-24" v-if="experienceName">
                {{ experienceName[0] }} <br>
                <span class="merriweather-bold-italic-24">{{ experienceName[1] }}</span>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      
      <div class="sticker-hub d-flex mt-4 pl-2" style="position: absolute; top: 0; left: 0; z-index: 10;">
        <img :src="greenNotePicto(lodging.score.toFixed())" :alt="lodging.score.toFixed()" v-if="lodging.score && !upHere" />
        <div class="sticker-info d-flex" v-if="lodging.score" @mouseover="upHere = true" @mouseleave="upHere = false">
          <div v-if="!isPhone" style="position:absolute; width: 48%;height: 338px;background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #A5D3AE;border-radius: 0px 53px 53px 0px;opacity: 1;" v-show="upHere">
            <div class="row pl-2">
              <div class="pl-3 ">
            <img style="width: 14px;height: 21px;" :src="greenNotePicto(lodging.score.toFixed())" :alt="lodging.score.toFixed()" v-if="lodging.score" />
              </div>
            <p class="raleway-reg-p13 mb-0 pl-1 pr-2">
              <b>{{ lodging.score.toFixed() }}</b
              >/10
            </p>
            </div>
            <div class="pl-4">
            <div class="mt-2">
            <p style="text-align: left;font: normal normal bold 13px/15px Raleway;letter-spacing: 0px;color: #000000;text-transform: uppercase;opacity: 1;">
              LA GREEN NOTE
              </p>
            </div>
            <div class="mt-3 pr-2">
              <p style="font: normal normal bold 13px/15px Raleway;">
                Pour intégrer la sélection, un hébergement doit obtenir une note globale d'au moins 5/10 — un niveau qui reflète déjà un fort engagement environnemental.</p>
            </div>
            <div class="mt-2 pr-2">
            <p style="text-align: left;font: normal normal normal 12px/14px Raleway;letter-spacing: 0px;color: #000000;opacity: 1;">
              Développée par Hortense, la Green Note évalue les établissements selon 10 critères d’éco-responsabilité. Chaque critère est noté sur 10, permettant d’attribuer une note globale de 1 à 10.</br></br>Les 10 critères d'éco-responsabilité pris en compte dans l'évaluation incluent des aspects tels que la gestion des déchets, l'efficacité énergétique, l'utilisation de sources d'énergie renouvelables, la conservation de l'eau, la promotion du transport durable, l'utilisation de matériaux écologiques, la sensibilisation à l'environnement, la formation du personnel aux éco-gestes etc.</br></br>À travers la Green Note, Hortense valorise les hébergements engagés et accompagne les voyageurs vers des choix plus durables.</p>
            </div>
          </div>
          </div>
          <div v-if="isPhone" style="position:fixed;background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #A5D3AE;border-radius: 0px 53px 53px 0px;opacity: 1;" v-show="upHere">
            <div class="row pl-2">
              <div class="pl-3 ">
                <img style="width: 14px;height: 21px;" :src="greenNotePicto(lodging.score.toFixed())" :alt="lodging.score.toFixed()" v-if="lodging.score" />
              </div>
              <p class="raleway-reg-p13 mb-0 pl-1 pr-2">
                <b>{{ lodging.score.toFixed() }}</b
                >/10
              </p>
            </div>
            <div class="pl-4">
              <div class="mt-2">
                <p style="text-align: left;font: normal normal bold 13px/15px Raleway;letter-spacing: 0px;color: #000000;text-transform: uppercase;opacity: 1;">
                  LA GREEN NOTE
                </p>
              </div>
              <div class="mt-3 pr-2">
                <p style="font: normal normal bold 13px/15px Raleway;">
                  Pour intégrer la sélection, un hébergement doit obtenir une note globale d'au moins 5/10 — un niveau qui reflète déjà un fort engagement environnemental.</p>
              </div>
              <div class="mt-2 pr-2">
                <p style="text-align: left;font: normal normal normal 12px/14px Raleway;letter-spacing: 0px;color: #000000;opacity: 1;">
                  Développée par Hortense, la Green Note évalue les établissements selon 10 critères d’éco-responsabilité. Chaque critère est noté sur 10, permettant d’attribuer une note globale de 1 à 10.</br></br>Les 10 critères d'éco-responsabilité pris en compte dans l'évaluation incluent des aspects tels que la gestion des déchets, l'efficacité énergétique, l'utilisation de sources d'énergie renouvelables, la conservation de l'eau, la promotion du transport durable, l'utilisation de matériaux écologiques, la sensibilisation à l'environnement, la formation du personnel aux éco-gestes etc.</br></br>À travers la Green Note, Hortense valorise les hébergements engagés et accompagne les voyageurs vers des choix plus durables.</p>
              </div>
            </div>
          </div>
          <p class="raleway-reg-p13 mb-0 pl-1 pr-2">
            <b>{{ lodging.score.toFixed() }}</b
            >/10
          </p>
          <p class="raleway-reg-p13 mb-0 pl-1 pr-2">Green note</p>
        </div>
      </div>
    </div>
    <div class="card-hub-info">
      <!-- Dernières Disponibilités Insert -->
      <div v-if="showLastAvailabilityInsert" class="dernières-disponibilités-insert">
        <div class="insert-content">
          <span class="insert-icon"><img src="../../images/wait_icon.svg" style="width: 7px; height: 9px;"></img></span>
          <span class="insert-text text-uppercase raleway-semi-p11">DERNIÈRES DISPONIBILITÉS</span>
        </div>
      </div>
      <!-- Discount Badges -->
      <div class="d-flex justify-content-between w-100" :class="isPhone ? 'align-items-center' : ''" v-if="lodging.lodging_discounts && lodging.lodging_discounts.length > 0">
          <CardDiscountBadges v-if="showFromLodgingsPage" :class="showLastAvailabilityInsert ? 'mt-0' : ''"  :lodging="lodging" />
          <div class="like-icon ml-auto">
            <img src="../../images/wishlistOn.svg" v-set-alt v-if="isIncludeInWishlist()" @click.stop="toggleLike()" />
            <img src="../../images/wishlist.svg" v-set-alt v-else @click.stop="toggleLike()" />
          </div>
      </div>
      <div class="hub-header mb-2" :class="lodging.lodging_discounts && lodging.lodging_discounts.length > 0 ? 'd-flex align-items-center justify-content-between' : ''">
        <div class="d-flex align-items-start justify-content-between w-100">
          <div class="d-flex align-items-center">
            <h2 class="d-flex flex-wrap raleway-bold-h3 mb-0 no-translate">{{ lodging.name }}
              <span
                v-if="Number(lodging.classification_outside_france) > 0"
                class="d-flex standing justify-content-center text-white mb-1 ml-1 mr-5"
              >
                <div
                  v-for="i in Number(lodging.classification_outside_france)"
                  :key="i"
                >
                  <img
                    src="../../images/picto_logement_entier_black.svg"
                    alt="Classification - hors atout france"
                    style="width: 15px; height: 15px;"
                  />
                </div>
              </span>
              <span v-else-if="lodging.standing && parseInt(lodging.standing) > 0" class="standing mb-1 ml-1" style="line-height: 14px;">
                <img src="../../images/Etoiles.svg" v-set-alt v-if="lodging.standing" v-for="i in Math.max(0, parseInt(lodging.standing) || 0)" :key="i" />
                <img v-if="lodging.standing && parseInt(lodging.standing) > 0" src="../../images/blanc.png" alt="white" />
              </span>
            </h2>
          </div>
          <div class="d-flex align-items-start">
            <div class="like-icon ml-1" v-if="!(lodging.lodging_discounts && lodging.lodging_discounts.length > 0)">
              <img 
                src="../../images/wishlistOn.svg" 
                class="mb-2"
                v-set-alt 
                v-if="isIncludeInWishlist()" 
                @click.stop="toggleLike()" 
              />
              <img 
                src="../../images/wishlist.svg" 
                class="mb-2"
                v-set-alt 
                v-else 
                @click.stop="toggleLike()" 
              />
            </div>
          </div>
        </div>
      </div>

      <div v-if="showMapfind" class="mobile-map-modal">
        <Mapfind :markers="markers" :lodgings="lodgingList" :selectedLodgingId="lodging.id" @close="closeMap" />
      </div>
      <div class="d-flex align-items-center mb-1" style="gap: 0.2rem;">
        <div class="lodge-type raleway-semi-p11 text-uppercase">
          {{ typeLabels[this.lodging.type] || "Lodges et lieux insolites" }}
        </div>
        <span style="font-style: normal;" v-if="lodging.is_entire">•</span>
        <span class="raleway-reg-p12" v-if="lodging.is_entire">
          {{ this.lodging.rooms_count || 1 }}
          {{ this.lodging.rooms_count > 1 ? 'Chambres' : 'Chambre' }}
        </span>
      </div>
      <p class="description-hub mb-0 raleway-reg-p13" v-if="lodging.country">{{ fullLocation }}  <span @click="displayMapfind" class="location-hub-desktop raleway-semi-p12">Voir sur la carte</span></p>
      <div @click="goToLodging()" id="green-experience-section">
        <!-- <div class="header" v-if="lodging.lodging_description.green_experience ">
          <span class="nights">+ DE 3 NUITS = GREEN EXPÉRIENCE</span>
          <span class="visit">{{ lodging.lodging_description.green_experience }}</span>
        </div> -->
        <div class="discount-details" v-if="lodging.lodging_description.green_experience_two">
          <img src="../../images/discount.png" class="discount-image" />
          <div class="details">
            <div class="details-1">
              <span class="discount">{{lodging.lodging_description.green_experience_two}}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 5px;" class="raleway-reg-p13 mt-auto justify-content-between w-100">
        <div v-if="lodging.ratings.length > 0" class="hub-reviews justify-content-start d-flex align-items-center">
          <img class="mr-1 ml-1" src="../../images/avis.svg" v-set-alt />
          <div class="review-info d-flex align-items-center flex-row mb-2">
            <i class="fa-solid fa-star ta-starr pl-1" style="font-size: 13px; margin-top: 3px;"></i>
            <div class="score-hub d-flex align-items-center" v-if="ratedLodgings">
              <p class="raleway-semi-p13 mb-0 pl-1 pr-2 text-nowrap">
                {{ lodging.lodging_description.rating_value || average }}/5
              </p>
              <a 
                :href="'/reservation-hotel/' + lodging.slug + '/avis'" 
                class="link-hortense text-nowrap" 
                v-if="lodging.ratings.length > 0"
              >
                {{ lodging.ratings.length }} avis
              </a>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column align-items-end w-100" v-if="this.lodging.lowest_price">
          <div class="d-flex flex-column align-items-end">
            <p class="raleway-reg-p15 mb-0">À partir de</p>
            <p class="raleway-semi-p15 mb-0">{{ this.lodging.lowest_price }} EUR <span class="raleway-reg-p13 mb-0">par nuit</span></p>
          </div>
        </div>
      </div>
      <div  class="reviews-btn">
        <a v-if="exclusive" style="width: 100%;" @click="openInNewWindowTwo(exclusive.slug, lodging.slug)" :href="'/offres-exclusives/' + this.exclusive.slug + '/' + this.lodging.slug" class="xs-btn-primary text-center" target="_blank" rel="noopener noreferrer">Voir les disponibilités</a>
        <a v-else style="width: 100%;" @click="openInNewWindow(lodging.slug)" class="xs-btn-primary text-center">Voir les disponibilités</a>
      </div>
    </div>
  </div>
</template>

<script>
import fetcher from 'packs/shared/api.js';
import Cardmap from 'components/cards/Cardmap.vue';
import Maptest from 'components/Maptest.vue';
import Mapfind from 'components/Mapfind.vue';
import CardDiscountBadges from '../shared/CardDiscountBadges.vue';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation.min.css';
import 'swiper/modules/pagination.min.css';

Swiper.use([Navigation, Pagination]);

export default {
  name: 'CardProductBigV2',
  props: ['lodging', 'dataMarker', 'user', 'exclusive', 'wishlistLodgings', 'showMapCard', 'to', 'from', 'lodgingList', 'showFromLodgingsPage', 'availabilityData'],
  components: { Maptest, Cardmap, Mapfind, CardDiscountBadges },
  data() {
    return {
      lodgingMount: this.lodging,
      showMap: false,
      showMapfind: false,
      mapfindKey: 0,
      markers: [],
      ratedLodgings: [],
      averageList: [],
      average: '-',
      upHere: false,
      showDiscountTooltip: null,
      savedScrollPosition: 0,
      swiperInstance: null,
      typeLabels: {
        Hotel: "Hôtels",
        "Maison et Villa": "Maisons et Villas",
        Guestroom: "Chambres d'Hôtes",
        Lodge: "Lodges et Lieux Insolites",
        Appartment: "Appartements",
        Chalet: "Chalets"
      }
    };
  },
  methods: {
    goToLodging() {
      const urlParams = new URLSearchParams(window.location.search);
      const typeParam = urlParams.get('base');
      localStorage.setItem('reservation_referrer', window.location.pathname + window.location.search);

      let newUrl = '/reservation-hotel/' + this.lodging.slug;
      if (typeParam === 'spring' || typeParam === 'summer') {
        newUrl += '?base=' + typeParam;
      }

      if (this.isPhone) {
        window.location.href = newUrl;
      } else {
        window.open(newUrl, '_blank');
      }
    },
    openInNewWindow(slug) {
      const urlParams = new URLSearchParams(window.location.search);
      const typeParam = urlParams.get('base');
      localStorage.setItem('reservation_referrer', window.location.pathname + window.location.search);
      
      let newUrl = '/reservation-hotel/' + slug;
      if (typeParam === 'spring' || typeParam === 'summer') {
        newUrl += '?base=' + typeParam;
      }
      if (this.isPhone) {
        window.location.href = newUrl;
      } else {
        window.open(newUrl, '_blank');
      }
    },
    greenNotePicto(score) {
      if (score === `${score}`) {
        return require(`../../images/greennote ${score}.svg`);
      } else {
        return require('../../images/blanc.png');
      }
    },
    async toggleLike() {
      try {
        if (this.user && Object.entries(this.user).length !== 0) {
          const response = await fetcher.patch('/wishlists/' + this.user.id, { lodging_id: this.lodging.id });
          this.wishlistLodgings = response.data.lodgings;
          // Emit event to parent to update wishlist state
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event : 'add_to_wishlist',
            ecommerce: {
              items: [{
                item_name: this.lodging.name,
                item_id: this.lodging.id,
                item_city: this.lodging && this.lodging.city ? this.lodging.city.name : 'Pruniers-en-Sologne',
                item_region: this.lodging && this.lodging.region ? this.lodging.region.name : 'Occitanie',
                item_category: 'lodging',
              }]
            }
          });
          this.$emit('wishlistUpdated', response.data.lodgings);
        } else {
          this.$root.$emit('openModal');
          window.scrollTo({
            top: 0,
            behaviour: 'smooth',
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    displayMap() {
      this.showMap = !this.showMap;
      this.markers = this.markerMap();
    },
    displayMapfind() {

      // For desktop: emit event to parent to focus on this lodging in MapTest
      if (!this.isPhone) {
        this.$emit('focusOnMap', {
          lodgingId: this.lodging.id,
          lodging: this.lodging
        });
        return; // Don't show the modal map for desktop
      }

      // For mobile: continue with existing logic
      this.closeMap();
      this.$emit('hideBigMap');

      // Clear previous map if exists
      if (this.mapInstance) {
        this.mapInstance.remove();
        this.mapInstance = null;
      }

      if (!Array.isArray(this.lodgingList) || this.lodgingList.length === 0) {
        console.warn('[CardProductBigV2] lodgingList is empty or not an array');
        return;
      }

      // Save scroll position before disabling scroll
      const currentScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.savedScrollPosition = currentScrollY;

      // Filter out invalid entries
      this.markers = this.lodgingList
        .filter(l => l && typeof l.longitude === 'number' && typeof l.latitude === 'number')
        .map(l => [l.longitude, l.latitude, l.id, l.lowest_price]);

      this.mapfindKey += 1; // Force re-render
      this.showMapfind = true;

      // Add body classes for modal behavior
      document.body.classList.add('map-active', 'no-scroll');
    },
    closeMap() {
      if (this.mapInstance) {
        this.mapInstance.remove();
        this.mapInstance = null;
      }
      this.showMapfind = false;
      this.$emit('hideSmallMap');

      // Add "fixed" class back to .search-lodging-banner when showMapfind is false
      const searchBanner = document.querySelector('.search-lodging-banner');
      if (searchBanner) {
        searchBanner.classList.add('fixed');
      }

      // Remove body classes
      document.body.classList.remove('map-active', 'no-scroll');

      // Restore scroll position
      this.$nextTick(() => {
        if (this.savedScrollPosition > 0) {
          window.scrollTo(0, this.savedScrollPosition);
        }
      });
    },
    markerMap() {
      return [this.lodging.longitude, this.lodging.latitude];
    },
    formatSource() {
      if (this.lodging.photo_banner) {
        return this.lodging.photo_banner
      } else {
        return 'https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0=';
      }
    },
    openInNewWindowTwo(slug_one, slug_two) {
      window.open('/offres-exclusives/' + slug_one + '/' + slug_two, '_blank');
    },
    formatStyle(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    isIncludeInWishlist() {
      if (this.wishlistLodgings) {
        for (const lodging of this.wishlistLodgings) {
          if (lodging.id === this.lodging.id) {
            return true;
          }
        }
      }
      return false;
    },
    ratedLodging() {
      if (this.lodging.reservations && this.lodging.reservations.length !== 0) {
        this.ratedLodgings = this.lodging.reservations.filter((el) => el.rated === true);
      }
      return this.ratedLodgings;
    },
    averageRate() {
      this.ratedLodgings.forEach((el) => {
        this.averageList.push(el.rate_average);
      });
      return this.averageList;
    },
    averageLodging() {
      if (this.averageList.length > 0) {
        this.average = (this.averageList.reduce((a, b) => a + b, 0) / this.averageList.length).toFixed(1);
      } else {
        this.average = '-';
      }
    },
    async fetchWishlist() {
      try {
        if (this.user) {
          const response = await fetcher.get('/wishlists.json');
          this.wishlistLodgings = response.data.lodgings;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async fetchLodgings() {
      try {
        this.ratedLodging();
        this.averageRate();
        this.averageLodging();
      } catch (e) {
        console.error(e);
      }
    },
    handleCardHover(isHovered) {
      // Emit hover event to parent component with lodging ID
      this.$emit('cardHover', {
        lodgingId: this.lodging.id,
        isHovered: isHovered
      });
    },
    initializeSwipers() {
      // Desktop swiper configuration with lazy loading
      if (document.querySelector(".lodging-image-slider")) {
        this.swiperInstance = new Swiper(".lodging-image-slider", {
          slidesPerView: 'auto',
          spaceBetween: 0,
          pagination: {
            el: ".lodging-image-slider .swiper-pagination",
            type: "bullets",
          },
          navigation: {
            nextEl: ".lodging-image-slider .swiper-button-next",
            prevEl: ".lodging-image-slider .swiper-button-prev",
          },
          loop: true,
          touchRatio: 1,
          touchAngle: 45,
          allowTouchMove: true,
          on: {
            slideChange: (swiper) => {
              this.loadAdjacentImages(swiper);
            },
            slideChangeTransitionEnd: (swiper) => {
              this.loadAdjacentImages(swiper);
            }
          }
        });
      }

      // Mobile swiper configuration with optimized touch handling and lazy loading
      if (document.querySelector(".lodging-image-slider-mobile")) {
        this.swiperInstance = new Swiper(".lodging-image-slider-mobile", {
          slidesPerView: 1,
          pagination: {
            el: ".lodging-image-slider-mobile .swiper-pagination",
            type: "fraction",
          },
          // Optimize touch behavior for mobile
          touchRatio: 1,
          touchAngle: 45, // Only respond to swipes within 45 degrees of horizontal
          threshold: 10, // Minimum distance to trigger swipe
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: true,
          allowTouchMove: true,
          // Prevent vertical scrolling interference
          touchStartPreventDefault: false,
          touchMoveStopPropagation: false,
          simulateTouch: true,
          // Only prevent default on horizontal swipes
          preventInteractionOnTransition: false,
          // Allow nested swipers and scrolling
          nested: false,
          // Resistance when swiping beyond bounds
          resistance: true,
          resistanceRatio: 0.85,
          on: {
            slideChange: (swiper) => {
              this.loadAdjacentImages(swiper);
            },
            slideChangeTransitionEnd: (swiper) => {
              this.loadAdjacentImages(swiper);
            }
          }
        });
      }
    },
    loadAdjacentImages(swiper) {
      // Preload images adjacent to current slide
      const currentIndex = swiper.activeIndex;
      const slides = swiper.slides;
      
      slides.forEach((slide, index) => {
        // Load current and adjacent slides (within 1 slide distance)
        if (Math.abs(index - currentIndex) <= 1) {
          const dataSrc = slide.getAttribute('data-src');
          if (dataSrc && !slide.style.backgroundImage) {
            // Set background image for lazy-loaded slides
            slide.style.backgroundImage = `url('${dataSrc}')`;
          }
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeSwipers();
    });
    this.fetchLodgings();
  },
  beforeDestroy() {
    if (this.swiperInstance && this.swiperInstance.destroy) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  },
  computed: {
  	showLastAvailabilityInsert() {
  		// Only show if availabilityData exists and availabilityPercentage < 50
  		if (!this.availabilityData) {
  			return false;
  		}
  		return this.availabilityData.show_insert == true;
  	},
  	availabilityPercentage() {
  		// Use availabilityData if available, otherwise fallback to lodging data
  		if (this.availabilityData && this.availabilityData.availability_percentage !== null && this.availabilityData.availability_percentage !== undefined) {
  			return this.availabilityData.availability_percentage;
  		}
  		return this.lodging.availability_percentage;
  	},
    fullLocation() {
      const capitalize = (str) => {
        if (!str) return '';
        return str
          .split('-') // split on hyphens
          .map(part =>
            part
              .split(' ') // split on spaces within each hyphen part
              .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              .join(' ')
          )
          .join('-');
      };

      const { country, region, department, city } = this.lodging;

      return [country?.name, region?.name, department?.name, city?.name]
        .filter(Boolean)
        .map(capitalize)
        .join(', ');
    },
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      }else{
        return false;
      }
    },
    defineWishlistLodgings() {
      return (this.wishlistLodgings = this.wishlist.lodgings);
    },
    experienceName() {
      if (this.lodging.experience_name) {
        const words = this.lodging.experience_name.split('\n');
        const firstWord = words.shift();
        const restOfSentence = words.join(' ');
        return [firstWord, restOfSentence];
      } else {
        return null;
      }
    },
    backgroundImage() {
      let url = this.lodging?.photo_banner?.trim();
      if (!url || url === 'null' || url === 'undefined') {
        url = 'https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0=';
      } else {
        url = encodeURI(url);
      }
      return `url("${url}")`;
    },
    displayPhotos() {
      const fallbackImage = 'https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0=';
      
      // Check if photos_keys exists and is an array with items
      if (this.lodging?.photos_keys && Array.isArray(this.lodging.photos_keys) && this.lodging.photos_keys.length > 0) {
        // Take up to 10 photos from photos_keys
        const photos = this.lodging.photos_keys.slice(0, 10).map(photo => {
          const photoURL = photo.url;
          if (photoURL && photoURL.trim() && photoURL !== 'null' && photoURL !== 'undefined') {
            // For CSS background-image, we need to handle special characters differently
            return photoURL.trim().replace(/['"]/g, ''); // Remove quotes that might break CSS
          }
          return fallbackImage;
        });
        
        // If we have valid photos, return them
        if (photos.length > 0) {
          return photos;
        }
      }
      
      // Fallback to photo_banner if available
      if (this.lodging?.photo_banner?.trim() && this.lodging.photo_banner !== 'null' && this.lodging.photo_banner !== 'undefined') {
        return [this.lodging.photo_banner.trim().replace(/['"]/g, '')]; // Remove quotes that might break CSS
      }
      
      // Final fallback to default image
      return [fallbackImage];
    },
    preloadedPhotos() {
      // Only preload first 2 images
      return this.displayPhotos.slice(0, 2);
    },
  },
};
</script>

<style lang="scss" scoped>

/* V2 Responsive Grid Card Styles */
#cardProduct-big-v2 {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  width: 100%;
  max-width: 1200px;
  gap: 0;
  transform: none;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .hub-img-zoom {
    position: relative;
    margin-bottom: 0;
    width: 100%;
    height: auto;
    min-height: 319px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: hidden;
    z-index: 0;
    cursor: pointer;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
  }

  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    z-index: 1;
  }

  .experience-name-text {
    position: absolute;
    bottom: 10px;
    left: 10px;
    color: white;
    line-height: 110%;
    z-index: 2;
  }

  .card-hub-info {
    width: 100%;
    max-width: none;
    padding: 1.5rem;
    border-top: 1px solid #f0f0f0;
  }

  .sticker-hub {
    position: absolute;
    background-color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
    align-items: center;
    width: 35%;
    z-index: 1;

    img {
      width: 19px;
      height: 28px;
    }
  }

  .catch-hub-phone {
    display: none;
  }

  .sticker-info {
    flex-direction: column;
  }

  .hub-img {
    width: 100%;
    height: 100%;
    padding-right: 2rem;
  }

  .hub-header {
    margin-top: 0.5rem;
    justify-content: space-between;
  }

  .standing {
    img {
      width: 15px;
    }
  }

  .description-location-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .location-hub {
    display: flex;
    cursor: pointer;
    
    img {
      width: 10px;
      height: 12px;
    }
  }

  .reviews-btn {
    display: flex;
    justify-content: space-between;
    
    .xs-btn-primary {
      width: 220px;
      height: 49px;
    }
  }

  .hub-reviews {
    img {
      width: 23px;
      height: 27px;
    }
    
    .review-info {
      flex-direction: column;
    }
  }

  #green-experience-section {
    width: fit-content;
    font-family: "Merriweather";
    font-size: 0.6rem;
    
    .header {
      display: flex;
      justify-content: space-between;
      border: 0.5px solid #d7d7d7;
      
      .nights {
        background-color: #d6e4d2;
        padding: 5px 10px;
        font-weight: bold;
        color: #425e3a;
      }
      
      .visit {
        padding: 5px 10px;
      }
    }
    
    .discount-details {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      
      img {
        width: 25px;
        height: 30px;
      }
      
      .details {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        padding: 10px;
        color: #000;
        
        .details-1 {
          display: flex;
          justify-content: flex-end;
        }
      }
      
      .details .separator {
        margin: 0 10px;
      }
    }
  }
}

// Tablet and larger screens - horizontal grid layout
@media only screen and (min-width: 768px) {
   #cardProduct-big-v2 {
     grid-template-columns: 1fr 1fr;
     grid-template-rows: 1fr;
     gap: 0;
     max-width: 1200px;
     align-items: stretch;
     
     .hub-img-zoom {
       min-height: 400px;
       border-top-left-radius: 7px;
       border-bottom-left-radius: 7px;
       border-top-right-radius: 0;
     }
     
     .card-hub-info {
       padding: 2rem;
       display: flex;
       flex-direction: column;
       justify-content: flex-start;
       border-top: none;
       border-left: 1px solid #f0f0f0;
       align-self: stretch;
     }

     .dernières-disponibilités-insert {
       height: 30px;
     }

     .card-discount-section {
       min-height: 22px;
     }

     /* Card with no badges/inserts - add margin-top to card-hub-info to align hub-header */
     &.card_without_discount .card-hub-info {
       margin-top: 77px !important;
     }

     /* Card with only insert - add margin-top to card-hub-info to align hub-header */
     &.card_with_discount:not(:has(.card-discount-section)) .card-hub-info {
       margin-top: 40px !important;
     }

     /* Card with only discount - add margin-top to card-hub-info to align hub-header */
     &.card_with_discount:not(:has(.dernières-disponibilités-insert)) .card-hub-info {
       margin-top: 40px !important;
     }

     &.card_with_discount:has(.card-discount-section):has(.dernières-disponibilités-insert) .dernières-disponibilités-insert {
        margin-bottom: 10px !important;
      }

     .description-location-wrapper {
       display: flex;
       flex-direction: row;
       gap: 1rem;
       align-items: center;
     }
   }
 }

// Large desktop screens
@media only screen and (min-width: 1024px) {
  #cardProduct-big-v2 {
    gap: 0;
    
    .hub-img-zoom {
      min-height: 309px;
    }
    
    .card-hub-info {
      padding: 1rem;
    }
  }
}

// Mobile devices
@media only screen and (max-width: 767px) {
  #cardProduct-big-v2 {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    width: 100%;
    gap: 0;
    margin: 0;
    
    .hub-img-zoom {
      width: 100%;
      min-height: 309px;
      border-radius: 0;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
    }
    
    .card-hub-info {
      width: 100%;
      padding: 1rem;
      border-top: 1px solid #f0f0f0;
      border-left: none;
    }
    
    .hub-img {
      width: 100%;
      height: auto;
      min-height: 309px;
      padding-right: 0;
    }
    
    .hub-header {
      margin-top: 0;
      justify-content: space-between;
      margin-right: 0;
    }
    
    .location-hub {
      display: none;
    }
    
    .catch-hub-phone {
      display: block;
    }
    
    .catch-hub {
      display: none;
    }
    
    .reviews-btn {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 1rem;
      
      .xs-btn-primary {
        width: 100%;
        min-width: 135px;
      }
    }
  }
}

// Extra small mobile devices
@media only screen and (max-width: 480px) {
  #cardProduct-big-v2 {
    .hub-img {
      width: 100%;
      height: auto;
      min-height: 250px;
    }
    
    .hub-img-zoom {
      min-height: 250px;
    }
    
    .card-hub-info {
      padding: 1rem;
    }
    
    .reviews-btn {
      .xs-btn-primary {
        height: 45px;
        font-size: 0.9rem;
      }
    }
  }
}


// Mobile map modal styles
.mobile-map-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background: white;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

@media (max-width: 485px) {
  body.map-active #navbar-main .top-bar,
  body.map-active #navbar-main #nav-phone .nav-phone {
    z-index: 1 !important;
  }

  body.map-active .mobile-map-modal {
    z-index: 9999 !important;
  }

  #map-find .modal-mask {
    display: flex !important;
    flex-direction: column-reverse;
  }
  
  #map-find .modal-container {
    padding: 0px !important;
    margin: 0px !important;
    width: 98.4vw !important;
  }
  
  #map-find .closing {
    top: 0vh;
    margin: 0px;
  }
}

// @media screen and (min-width: 786px) {
//   .card_without_discount {
//     .card-hub-info {
//       margin-top: 62px !important;
//     }
//   } 
// }

.swiper-button-prev, .swiper-button-next {
  top: 50% !important;
  width: 30px !important;
  height: 30px !important;
  background: transparent !important;
  cursor: pointer;
  border-radius: 9999px;
  outline: 0;
  background-color: rgba(255, 255, 255, 0.7) !important;
  padding: 0.5rem;
  transition: all 0.3s ease;
  opacity: 0;
  visibility: hidden;
  z-index: 10;
}

.swiper-button-prev:hover, .swiper-button-next:hover {
  background-color: rgba(255, 255, 255, 1) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: scale(1.05);
}

.swiper-button-next:after, .swiper-button-prev:after {
  font-size: 15px;
  color: black;
  z-index: 10;
}

.swiper-container {
  width: 100%;
  height: 100%;
  
  &:hover {
    .swiper-button-prev, .swiper-button-next {
      opacity: 1;
      visibility: visible;
    }
  }
}

// Mobile swiper container specific styles
.lodging-image-slider-mobile {
  width: 100%;
  height: 100%;
  touch-action: pan-y pinch-zoom;
  
  .swiper-container {
    touch-action: pan-y pinch-zoom;
  }
}

.swiper-wrapper {
  display: flex;
  transition-timing-function: ease;
}

.swiper-slide {
  width: 100% !important;
  background-size: cover;
  touch-action: pan-x pinch-zoom;
  background-position: center;
}

// Mobile-specific touch handling
@media screen and (max-width: 767px) {
  .lodging-image-slider-mobile {
    touch-action: pan-y pinch-zoom;
    
    .swiper-slide {
      touch-action: pan-x pan-y pinch-zoom;
    }
    
    .swiper-wrapper {
      touch-action: pan-x pan-y pinch-zoom;
    }
  }
}

@media screen and (max-width: 767px) {
  .swiper-pagination {
    position: absolute;
    bottom: 10px;
    right: 10px;
    background: rgba(0, 0, 0, .5);
    color: #fff;
    padding: 5px 10px;
    border-radius: 3px;
    font-size: .9rem;
    z-index: 10;
    width: fit-content;
    margin-left: auto;
  }
  
}

.lodge-type {
  border: 1px solid #2C5E4B;
  border-radius: 15px;
  color: #2C5E4B;
  height: 20px;
  padding: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.location-hub-desktop {
  text-decoration: underline;
  color: #2C5E4B;
  cursor: pointer;

  &::before {
    content: '•';
    display: inline-block;
    margin-right: 5px;
    color: black;
  }
}

/* Dernières Disponibilités Insert Styles */
.dernières-disponibilités-insert {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #D56A70;
  border-radius: 15px;
  padding: 0 12px 4px 12px;
  width: max-content;

  @media (max-width: 767px) {
    margin-bottom: 10px;
  }

  .insert-icon {
    flex-shrink: 0;
  }

  .insert-text {
    color: #D56A70;
  }
}
</style>


<style lang="scss">
.swiper-pagination-bullet-active {
  background: white !important;
}
</style>
